import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64042ae2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-issue" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "required-red" }, "*", -1))
const _hoisted_3 = { style: {"margin-top":"20px"} }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "label-with-status" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "header-issue" }
const _hoisted_8 = { class: "header-issue" }
const _hoisted_9 = { class: "btn-bottom" }

import {
  ImageLossAlert,
  SamplingPointImageStatus,
  IssueType,
  IssueSubType,
  IssueDiagnosis,
} from "@/types/issueMonitoring.type";
import { ref, onMounted, computed, reactive } from "vue";
import { getSamplingPointsImageStatus } from "@/service/samplingPointImageStatus.service.ts";
import { Filter } from "@/types/filter.type";
import { getIssueType } from "@/service/issueType.service.ts";
import { Check, Close } from "@element-plus/icons-vue";
import { useStore } from "vuex";
import { RootState } from "@/types/state.type";
import { getCamerasConfigurationByStationId } from "@/service/cameraConfiguration.service";
import { getSamplingPointById } from "@/service/samplingpoint.service";
import { Station } from "@/types/station.type";
import { CircleCheck, CircleClose } from "@element-plus/icons-vue";
import { ElMessage, ElNotification } from "element-plus";
import { useI18n } from "vue-i18n";
import { postImageLossAlert } from "@/service/imagelossalert.service.ts";
import type { FormRules } from "element-plus";
import { UserAccess } from "@/types/auth.type";


export default /*#__PURE__*/_defineComponent({
  emits: ["close", "getIssue"],
  setup(__props, { emit }: { emit: ({
  (e: "close"): void;
  (e: "getIssue"): void;
}), expose: any, slots: any, attrs: any }) {

const samplingpoints = ref<SamplingPointImageStatus[]>([]);
const store = useStore<RootState>();
const issueType = ref<IssueType>([]);
const activeName = ref("first");
const user: UserAccess = computed(() => {
  return store.state.auth.user;
});

const cameras = ref<{ label: string; value: string; modele: boolean }[]>([]);
const camerasWithIssue = ref<string[]>([]);
const issue = ref<ImageLossAlert>({} as ImageLossAlert);
const issueDiagnosis = ref<IssueDiagnosis>({} as IssueDiagnosis);
const customer = ref("");
const { t } = useI18n();



const rules = reactive<FormRules<ImageLossAlert>>({
  samplingPoint: [
    { required: true, message: "Punto de monitorización is required", trigger: "blur" },
  ],
  "issue.type.name": [{ required: true, message: "Type is required", trigger: "blur" }],
  fromDateTime: [{ required: true, message: "Datetime is required", trigger: "blur" }],
  camera: [{ required: true, message: "Camera is required", trigger: "blur" }],
});

onMounted(async () => {
  const filter: Filter = {
    fields: {
      "samplingpointimagestatus.stationOperation": { operator: "equal", value: true },
    },
  };
  samplingpoints.value = (await getSamplingPointsImageStatus(undefined, undefined, filter)).data;
  const filterIssue: Filter = {
    fields: {
      stationOperation: { operator: "equal", value: true },
    },
  };
  issueType.value = await getIssueType(undefined, undefined, filterIssue);
  issue.value.status = true;
  issue.value.origin = "MANUAL";
  //issue.value.responsable = { id: user.value.id };
  issueDiagnosis.value.isManual = true;
  //issueDiagnosis.value.responsable = { id: user.value.id };
});

const beforeLeave = (newName: string, oldName: string) => {
  // Solo controlar cuando intenta ir a la segunda pestaña
  if (newName === "second") {
    const notIssue =
      !issue.value.samplingPoint ||
      !issue.value.type ||
      !issue.value.fromDateTime ||
      camerasWithIssue.value.length === 0;

    if (notIssue) {
      ElMessage.warning(
        `${t("warning.notIssue", {
          type: `"${t("label.mainInfo")}"`.toLowerCase(),
        })}`
      );
      return false; // bloquea el cambio
    }
  }

  return true; // permite cambio
};

const updateFilter = () => {
  issue.value.type.subtype = {} as IssueSubType;
};

const getCameras = async () => {
  cameras.value = [];
  if (issue.value.samplingPoint?.id) {
    const samplingPoint = await getSamplingPointById(issue.value.samplingPoint.id);
    if ((samplingPoint.station as Station)?.id) {
      const camerasConfiguration = await getCamerasConfigurationByStationId(
        (samplingPoint.station as Station).id
      );
      camerasConfiguration?.forEach((_) => {
        cameras.value.push({ label: _.camera.code, value: _.camera.code, modele: _.modele });
      });
      customer.value = samplingPoint.container.holder;
    }
  }
};

const saveIssue = async () => {
  for (const camera of camerasWithIssue.value) {
    issue.value.issueDiagnosis = issueDiagnosis.value;
    issue.value.fromDateTime = new Date(issue.value.fromDateTime).toISOString();
    issue.value.camera = camera;

    const newIssue = await postImageLossAlert(issue.value);

    if (newIssue) {
      ElNotification.success({
        message: `
    ${t("success.action")} <br/>
    ${t("label.issueId")}: <b>${newIssue.code}</b>
  `,
        offset: 100,
        dangerouslyUseHTMLString: true,
      });
    }
  }
  emit("getIssue");
  cancelIssue();
};

const cancelIssue = () => {
  emit("close");
};

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_checkbox_button = _resolveComponent("el-checkbox-button")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createBlock(_component_el_tabs, {
    modelValue: activeName.value,
    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((activeName).value = $event)),
    class: "demo-tabs",
    "before-leave": beforeLeave
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_tab_pane, {
        label: _ctx.$t('label.mainInfo'),
        name: "first"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_card, {
            shadow: "never",
            class: "card-bottom"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t("label.mainInfo")), 1)
              ]),
              _createVNode(_component_el_form, {
                ref: "ruleFormRef",
                model: issue.value,
                rules: _unref(rules),
                "label-width": "180px",
                "label-position": "left"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_row, { gutter: 10 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.samplingPoint'),
                            prop: "samplingPoint"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: issue.value.samplingPoint,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((issue.value.samplingPoint) = $event)),
                                "value-key": "id",
                                filterable: "",
                                style: {"width":"90%"},
                                onChange: getCameras
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(samplingpoints.value, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.samplingPoint.id,
                                      label: item.samplingPoint.name,
                                      value: item.samplingPoint
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.customer')
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(customer.value ?? "-"), 1)
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.identification'),
                            prop: "origin"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(issue.value.origin?.charAt(0).toUpperCase() + issue.value.origin?.slice(1).toLowerCase()), 1)
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.responsible'),
                            prop: "responsible"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(issue.value.responsable?.email), 1)
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.issueDescription'),
                            prop: "issue.type.name"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: issue.value.type,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((issue.value.type) = $event)),
                                "value-key": "name",
                                onChange: _cache[2] || (_cache[2] = ($event: any) => (updateFilter())),
                                style: {"width":"90%"}
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(issueType.value, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item,
                                      label: item.name,
                                      value: item
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.subTypeIssue')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: issue.value.subType,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((issue.value.subType) = $event)),
                                "value-key": "name",
                                style: {"width":"90%"}
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(issue.value?.type?.subTypes ?? [], (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item,
                                      label: item.name,
                                      value: item
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.startDate'),
                            prop: "fromDateTime"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_date_picker, {
                                modelValue: issue.value.fromDateTime,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((issue.value.fromDateTime) = $event)),
                                type: "datetime",
                                format: "YYYY-MM-DD HH:mm",
                                placeholder: "DD/MM/AAAA hh:mm",
                                style: {"width":"90%"}
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.endDateTime'),
                            prop: "toDateTime"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_date_picker, {
                                modelValue: issue.value.endDateTime,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((issue.value.endDateTime) = $event)),
                                type: "datetime",
                                format: "YYYY-MM-DD HH:mm",
                                placeholder: "DD/MM/AAAA hh:mm",
                                style: {"width":"90%"}
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "rules"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, {
            class: "card-bottom",
            gutter: 10
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_card, { shadow: "never" }, {
                    default: _withCtx(() => [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.$t("label.incident_cancellation")), 1),
                      _createVNode(_component_el_form, {
                        ref: "ruleFormRef",
                        model: issue.value,
                        "label-width": "180px",
                        "label-position": "left"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_row, { gutter: 10 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    label: _ctx.$t('label.statusIssue'),
                                    prop: "origin"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_switch, {
                                        modelValue: issue.value.status,
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((issue.value.status) = $event)),
                                        "active-action-icon": _unref(CircleCheck),
                                        "inactive-action-icon": _unref(CircleClose),
                                        disabled: ""
                                      }, null, 8, ["modelValue", "active-action-icon", "inactive-action-icon"])
                                    ]),
                                    _: 1
                                  }, 8, ["label"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    label: _ctx.$t('label.note'),
                                    prop: "status"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: issue.value.note,
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((issue.value.note) = $event)),
                                        rows: 2,
                                        autosize: { maxRows: 2, minRows: 2 },
                                        maxlength: "100",
                                        "show-word-limit": "",
                                        type: "textarea",
                                        "word-limit-position": "outside"
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }, 8, ["label"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["model"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_card, { shadow: "never" }, {
                    default: _withCtx(() => [
                      _createElementVNode("h3", null, [
                        _createVNode(_component_el_row, null, {
                          default: _withCtx(() => [
                            _hoisted_2,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t("label.camera")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_3, [
                        (cameras.value.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                              _createVNode(_component_el_checkbox_group, {
                                modelValue: camerasWithIssue.value,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((camerasWithIssue).value = $event)),
                                size: "small"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cameras.value, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_checkbox_button, {
                                      key: item.value,
                                      label: item.value
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", _hoisted_5, [
                                          _createTextVNode(_toDisplayString(item.label) + " ", 1),
                                          (item.modele)
                                            ? (_openBlock(), _createBlock(_component_el_icon, {
                                                key: 0,
                                                color: "#67C23A"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(CircleCheck))
                                                ]),
                                                _: 1
                                              }))
                                            : (_openBlock(), _createBlock(_component_el_icon, {
                                                key: 1,
                                                color: "#F56C6C"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(CircleClose))
                                                ]),
                                                _: 1
                                              }))
                                        ])
                                      ]),
                                      _: 2
                                    }, 1032, ["label"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t("warning.notCameras")), 1))
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_el_tab_pane, {
        label: _ctx.$t('label.diagnosis'),
        name: "second"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_card, {
            class: "card-bottom",
            shadow: "never"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form, {
                ref: "diagnosisFormRef",
                model: issue.value,
                "label-width": "180px",
                "label-position": "left"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.$t("label.diagnosis")) + " " + _toDisplayString(_ctx.$t("label.manual").toLowerCase()), 1)
                  ]),
                  _createVNode(_component_el_row, { gutter: 10 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.responsible')
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(user)?.email), 1)
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.diagnosis'),
                            prop: "samplingPoint"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: issueDiagnosis.value.diagnosis_manual,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((issueDiagnosis.value.diagnosis_manual) = $event)),
                                maxlength: "150",
                                "show-word-limit": "",
                                type: "textarea",
                                "word-limit-position": "outside"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.solution_proposal'),
                            prop: "samplingPoint"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: issueDiagnosis.value.solution_proposal_manual,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((issueDiagnosis.value.solution_proposal_manual) = $event)),
                                maxlength: "150",
                                "show-word-limit": "",
                                type: "textarea",
                                "word-limit-position": "outside"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_card, {
            class: "card-bottom",
            shadow: "never"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form, {
                ref: "diagnosisFormRef",
                model: issue.value,
                "label-width": "180px",
                "label-position": "left"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.$t("label.note")), 1)
                  ]),
                  _createVNode(_component_el_row, { gutter: 10 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: issueDiagnosis.value.note,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((issueDiagnosis.value.note) = $event)),
                                maxlength: "100",
                                "show-word-limit": "",
                                type: "textarea",
                                "word-limit-position": "outside"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["label"]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, { onClick: cancelIssue }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("btn.cancel")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              disabled: beforeLeave,
              onClick: saveIssue
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("btn.save")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})